import { useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

import { BlockDeletionPresentationService } from '../services/block-deletion-presentation';
import { DeletionPendingLine } from './deletion-pending-line';

/**
 * The queued trash or permanent delete of a table or automation, as page,
 * canvas and sidebar show it, also when the block is hidden there: its phase
 * and the action of the phase. A queued restore shows nothing.
 */
export function BlockDeletionPendingLine({
  docId,
  blockId,
}: {
  docId: string;
  blockId: string;
}) {
  const presentations = useService(BlockDeletionPresentationService);
  const presentation = useLiveData(
    useMemo(
      () => presentations.presentation$(docId, blockId),
      [presentations, docId, blockId]
    )
  );
  if (
    presentation.state === 'none' ||
    presentation.operation === 'database.restore' ||
    presentation.operation === 'automation.restore'
  ) {
    return null;
  }
  const { mutationId } = presentation;
  return (
    <DeletionPendingLine
      permanent={
        presentation.operation === 'database.permanentDelete' ||
        presentation.operation === 'automation.permanentDelete'
      }
      phase={presentation.state}
      cancel={() => presentations.cancelQueuedTrash(mutationId)}
      retry={() => presentations.retryUnconfirmed(mutationId)}
      testId="block-deletion-pending"
    />
  );
}
